import React, { FC, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';

import { CampaignTypeFilter } from '@dev/ee-api/ee-api-models';
import { Paper } from '@dev/ee-components';

import useMobile from '@/services/hooks/useMobile';
import { ApplicationState } from '@/store';
import { GetCampaigns, UnpickAllCampaigns } from '@/store/campaigns/actions';
import PaginationComponent from './components/PaginationComponent';
import TableComponent from './components/TableComponent';
import { useRequestParams } from './hooks/useRequestParams';
import TableFilters from './components/TableFilters';

const CampaignsWrapper = styled.div`
    .MuiTableCell-root {
        font-weight: 400;
    }

    .MuiTypography-body1 a {
        white-space: nowrap;
    }

    .campaign-name {
        word-break: break-all;
        overflow: hidden;
        text-overflow: ellipsis;
    }

    .MuiTableSortLabel-root {
        white-space: nowrap;
    }
`;

const AutorespondersList: FC = (): JSX.Element => {
    const dispatch = useDispatch();
    const { campaigns } = useSelector((state: ApplicationState) => state);
    const requestParams = useRequestParams();
    const screenCampaignType = [CampaignTypeFilter.Automated];
    const isMobile = useMobile();

    useEffect(() => {
        window.scrollTo(0, 0);
        dispatch(GetCampaigns(requestParams));

        return () => {
            dispatch(UnpickAllCampaigns());
        };
    }, []);

    return (
        <CampaignsWrapper>
            {isMobile ? (
                <>
                    <TableFilters />
                    <TableComponent screenCampaignType={screenCampaignType} />
                    {!campaigns.loading && !!campaigns?.statusCount?.total && (
                        <Paper>
                            <PaginationComponent />
                        </Paper>
                    )}
                </>
            ) : (
                <Paper margin={{ top: 32 }}>
                    <TableFilters />
                    <TableComponent screenCampaignType={screenCampaignType} />
                    <PaginationComponent />
                </Paper>
            )}
        </CampaignsWrapper>
    );
};

export default AutorespondersList;
